import { VueSupabaseClient } from "./VueSupabaseClient";
export function install(app, options) {
    const supabase = new VueSupabaseClient(options.supabaseUrl, options.supabaseKey, options.supabaseOptions);
    supabase.install(app);
}
const VueSupabasePlugin = {
    install,
};
export { SupabaseClient, } from "@supabase/supabase-js";
export * from "./composables";
export { createVueSupabase } from "./VueSupabaseClient";
export default VueSupabasePlugin;
//# sourceMappingURL=index.js.map